import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: "grid", placeItems: "center", height: "100vh" }}>
        <div className="auth-loader" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

/** Weigert partner_nod-users in Merkatura-modules: ze worden hard
 *  geredirect naar hun portal. Plaats binnen RequireAuth.
 *
 *  Voorkomt dat NOD-partners via directe URL (/dashboard, /orders, /nod-stock,
 *  /beheer/...) iets van de Merkatura-admin-interface zien. */
export function RequireNonPartner({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user?.role === "partner_nod") {
    return <Navigate to="/nod-portal/stock" replace />;
  }
  return <>{children}</>;
}

/** Spiegelbeeld: alleen partner_nod (of admin/owner) mag in /nod-portal/* zitten.
 *  Een rare niet-partner-user die /nod-portal/stock typt → naar / (RoleHome). */
export function RequirePartnerOrOwner({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  const isPartner = user?.role === "partner_nod";
  const isOwner = !!user?.is_owner;
  if (!isPartner && !isOwner) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
